import { useState } from "react";
import { THEME_COLOR } from "../../config/club";
import EditCoverPhotoModal from "./EditCoverPhotoModal";

export default function PlayerHeaderCard({
  user,
  setProfile,
  winRate,
  setEditing,
  isOwnProfile,
  handleShare,
  setShowQr,
  setUser
}) {
  const [showPreview, setShowPreview] = useState(false);

  const winRateColor =
    winRate >= 60
      ? "#10B981"
      : winRate >= 45
        ? THEME_COLOR
        : "#EF4444";

  const userPhoto = user.photoURL || "/img/rrc2.png";
  const coverPhoto = user.coverPhoto || "/img/bg.jpg";
  const [showEditCover, setShowEditCover] = useState(false);

  return (
    <>
      <div
        className="mb-4 overflow-hidden position-relative"
        style={{
          borderRadius: "28px",
          background: "var(--card-bg)",
          border: "1px solid var(--border-color)",
          boxShadow: "0 12px 30px rgba(0,0,0,0.08)"
        }}
      >
        {/* COVER PHOTO */}
        <div
          style={{
            height: "150px",
            backgroundImage: `url(${coverPhoto})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative"
          }}
        >
          {/* Dark overlay for readability */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to bottom, var(--cover-overlay-top), var(--cover-overlay-bottom))"
            }}
          />

          {/* Edit Cover Button */}
          {isOwnProfile && (
            <button
              onClick={() => setShowEditCover(true)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "rgba(0,0,0,0.5)",
                border: "none",
                color: "#fff",
                borderRadius: "10px",
                padding: "6px 10px",
                fontSize: "0.8rem"
              }}
            >
              <i className="bi bi-camera me-1" />
              Edit
            </button>
          )}
        </div>

        {/* CONTENT */}
        <div className="px-4 pb-4" style={{ marginTop: "-55px" }}>
          <div className="d-flex justify-content-between align-items-end mb-3">

            {/* Avatar */}
            <div
              onClick={() => setShowPreview(true)}
              style={{ cursor: "zoom-in" }}
              className="position-relative"
            >
              <div
                style={{
                  padding: "4px",
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${THEME_COLOR}, #7C3AED)`
                }}
              >
                <img
                  src={userPhoto}
                  alt={user.displayName}
                  width="100"
                  height="100"
                  className="rounded-circle"
                  style={{
                    objectFit: "cover",
                    border: "4px solid var(--card-bg)"
                  }}
                />
              </div>

              {/* Level Badge */}
              <div
                className="position-absolute bottom-0 end-0 d-flex align-items-center justify-content-center"
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "12px",
                  background: THEME_COLOR,
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: 900,
                  border: "3px solid var(--card-bg)"
                }}
              >
                {user.level || 1}
              </div>
            </div>

            {/* Actions */}
            <div className="d-flex gap-2 mb-2">
              <PremiumIconButton onClick={handleShare} icon="bi-share-fill" />
              {isOwnProfile && (
                <>
                  <PremiumIconButton onClick={() => setShowQr(true)} icon="bi-qr-code" />
                  <PremiumIconButton onClick={() => setEditing(true)} icon="bi-pencil-fill" />
                </>
              )}
            </div>
          </div>

          {/* Name + Info */}
          <div>
            <h2
              className="mb-1"
              style={{
                fontWeight: 900,
                letterSpacing: "-0.02em",
                color: "var(--text-color)"
              }}
            >
              {user.displayName}
            </h2>

            <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
              <span
                style={{
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  padding: "6px 12px",
                  borderRadius: "999px",
                  backgroundColor: "var(--surface-bg)",
                  color: "var(--muted-text)",
                  border: "1px solid var(--border-color)"
                }}
              >
                @{user.username}
              </span>

              <div
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 800,
                  padding: "6px 12px",
                  borderRadius: "999px",
                  backgroundColor: `${winRateColor}20`,
                  color: winRateColor,
                  border: `1px solid ${winRateColor}40`
                }}
              >
                {winRate}% Win Rate
              </div>
            </div>
            {user.bio && (
              <p
                className="mt-3 mb-0"
                style={{
                  fontSize: "0.9rem",
                  lineHeight: "1.6",
                  color: "var(--muted-text)",
                  maxWidth: "100%"
                }}
              >
                {user.bio}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {showPreview && (
        <div
          onClick={() => setShowPreview(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.75)",
            backdropFilter: "blur(12px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <img
              src={userPhoto}
              alt="Preview"
              style={{
                maxHeight: "80vh",
                maxWidth: "90vw",
                borderRadius: "24px"
              }}
            />
          </div>
        </div>
      )}
      {showEditCover && (
        <EditCoverPhotoModal
          user={user}
          setProfile={setProfile}
          profile={user}
          setUser={setUser}
          onClose={() => setShowEditCover(false)}
        />
      )}
    </>
  );
}

function PremiumIconButton({ onClick, icon }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "40px",
        height: "40px",
        borderRadius: "14px",
        backgroundColor: "var(--surface-bg)",
        border: "1px solid var(--border-color)",
        color: "var(--text-color)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <i className={`bi ${icon}`} />
    </button>
  );
}